import React from 'react';
import noop from 'lodash/noop';
import EditFilterModalAsync from '@atlassian/jira-edit-filters-modal/src/async.tsx';
import type { AppProps } from '@atlassian/jira-edit-filters-modal/src/model/index.tsx';
import type { SharePermission } from '@atlassian/jira-shared-types/src/share-permission.tsx';
import type { ModalProps } from '../../types.tsx';

export type EditFilterModalOptions = {
	readonly id: string;
	readonly sharePermissions: SharePermission[];
	readonly name: string;
	readonly description: string;
};

export type Props = AppProps & ModalProps;

const EditFilter = ({
	sharePermissions,
	editPermissions,
	id,
	name,
	description,
	onClose,
}: Props) => {
	const onSuccess = () => {
		onClose();

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.location.reload();
	};
	return (
		<EditFilterModalAsync
			id={id}
			sharePermissions={sharePermissions}
			editPermissions={editPermissions}
			name={name}
			description={description}
			onInitiateSuccess={noop}
			onCancel={onClose}
			onEdited={onSuccess}
		/>
	);
};

export default EditFilter;
